import { render, staticRenderFns } from "./MediaViewer.vue?vue&type=template&id=96cb1ac8&scoped=true&lang=pug"
import script from "./MediaViewer.vue?vue&type=script&lang=js"
export * from "./MediaViewer.vue?vue&type=script&lang=js"
import style0 from "./MediaViewer.vue?vue&type=style&index=0&id=96cb1ac8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cb1ac8",
  null
  
)

export default component.exports